import { OUTBOUND_LCF, RETURN_LCF } from "@app/constants/seat-selection-first";
import { isRoundtrip } from "@app/helpers/search";

import type { NavigationState } from "../use-navigation";

import {
  OPEN_DRAWER_KEY,
  VIEW_KEY,
  SELECTED_LEG_CARD_ID_KEY,
  TRIP_ID_KEY,
  CART_ID_KEY,
  SELECTED_SEATS_KEY,
  SEGMENT_ID_KEY,
  RETURN_DATE_KEY,
  JOURNEY_ID_KEY
} from "../../helpers/views/constants";

type SegmentId = string;
type SeatId = string;
export type SelectedSeats = Record<SegmentId, Array<SeatId>>;
export type SelectedSeatsBySegment = Array<SelectedSeats | null>;
export type SelectedSeatsQueryParam = SelectedSeatsBySegment | number;

export const getAndDecode = (collection: URLSearchParams, key: string) => {
  const value = collection.get(key);
  return value ? decodeURIComponent(value) : null;
};

const getAndDecodeSeats = (collection: URLSearchParams, key: string) => {
  const value = getAndDecode(collection, key);
  return value ? (JSON.parse(value) as SelectedSeatsQueryParam) : 0;
};

const getFromState = (state: NavigationState, key: keyof NavigationState) => {
  return state?.[key] || null;
};

export const decodeSearchParams = (
  search_params: URLSearchParams,
  history_state: NavigationState
) => {
  const leg_card_id =
    getAndDecode(search_params, SELECTED_LEG_CARD_ID_KEY) ||
    getFromState(history_state, SELECTED_LEG_CARD_ID_KEY);

  const outbound_leg_card_id_class_and_fare = getAndDecode(
    search_params,
    OUTBOUND_LCF
  );
  const return_leg_card_id_class_and_fare = getAndDecode(
    search_params,
    RETURN_LCF
  );
  const trip_id = getAndDecode(search_params, TRIP_ID_KEY);
  const cart_id = getAndDecode(search_params, CART_ID_KEY);
  const segment_id = getAndDecode(search_params, SEGMENT_ID_KEY);
  const selected_seats = getAndDecodeSeats(search_params, SELECTED_SEATS_KEY);
  const is_roundtrip = isRoundtrip({
    return_date: getAndDecode(search_params, RETURN_DATE_KEY)
  });
  const view = getAndDecode(search_params, VIEW_KEY);
  const drawer = getAndDecode(search_params, OPEN_DRAWER_KEY);
  const utm_campaign = getAndDecode(search_params, "utm_campaign");
  const journey_id = getAndDecode(search_params, JOURNEY_ID_KEY);

  return {
    leg_card_id,
    outbound_leg_card_id_class_and_fare,
    return_leg_card_id_class_and_fare,
    trip_id,
    cart_id,
    segment_id,
    selected_seats,
    is_roundtrip,
    view,
    drawer,
    utm_campaign,
    journey_id
  };
};
